import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ObsoleteProductService } from './obsolete-product.service';
import { SearchCriteria } from '../../product-list.model';

@Component({
  selector: 'obsolete-product',
  templateUrl: './obsolete-product.component.html',
  styleUrls: ['./obsolete-product.component.scss'],
  standalone: false,
})
export class ObsoleteProductComponent {
  /**
   * Observable that indicates whether obsolete products should be displayed.
   */
  public showObsolete$ = this.obsoleteProductService.getStatus();

  constructor(
    private obsoleteProductService: ObsoleteProductService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  /**
   * Toggles the display status of obsolete products.
   * @param withDiscontinued New status (true to show, false to hide)
   *
   * Note: The routing/search API now expects a `customFilters` string (e.g. "withDiscontinued:true").
   * This helper converts the boolean flag into the appropriate customFilters representation.
   */
  public toggleObsolete(withDiscontinued: boolean): void {
    // Convert boolean flag into customFilters string expected by the backend/search API.
    // Use explicit true/false so the value is preserved in the query params.
    const customFilters = `withDiscontinued:${withDiscontinued ? 'true' : 'false'}`;
    this.route({ customFilters });
  }

  /**
   * Routes to the next product listing page, using the given `queryParams`. The
   * `queryParams` support sorting, pagination and querying.
   *
   * The `queryParams` are delegated to the Angular router `NavigationExtras`.
   */
  protected route(queryParams: SearchCriteria): void {
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
    });
  }
}
